<template>
   <div>
     <TopoComponent></TopoComponent>
      <div class="container vertical-align login escolha mt-4">
        <div class="row">
          <div class="col-md-12 text-center">
            <h2>Boas-vindas à Conexa Saúde</h2>
            <p class="espaco"></p>
            <p class="espaco"></p>
            <!-- <h3 class="mt-5 text-center" v-show="isMobile && (acessoDiretoAppUrl != null && acessoDiretoAppUrl != '')">
              <h3>Já baixei o APP</h3>
              <button class="btn btn-lg btn-primary btn-block button success mt-4" type="button" @click="acessarAgora">ACESSAR AGORA!</button>
            </h3> -->
            <h3 class="mt-5 mensagemFalha text-center" v-show="isMobile">
              <p v-if="isConexaApp"><strong>ABRA o APP Conexa Saúde</strong>, clique em LOGIN e informe o seu E-MAIL e a SENHA que <i>você acabou de cadastrar</i> durante a ativação de sua conta!</p>
              <p v-if="!isConexaApp"><strong>ABRA nosso APP</strong>, clique em LOGIN e informe o seu E-MAIL e a SENHA que <i>você acabou de cadastrar</i> durante a ativação de sua conta!</p>
            </h3>
            <div class="text-center" v-show="isMobile && origem != 'APP'">
                <p class="espaco"></p>
                <span class="baixeApp">CASO NÃO TENHA O APP INSTALADO, BAIXE AGORA!</span>	
                <div class="clearfix"></div>
                <a :href="iosUrl" target="_blank" v-show="isIOS || isOutroDisp">
                    <img src="/assets/img/app-store.png" class="imgApp">
                </a>
                <a :href="androidUrl" target="_blank" v-show="isAndroid || isOutroDisp">
                    <img src="/assets/img/app-google.png" class="imgApp">
                </a>
                <div class="clearfix"></div>
            </div>
            <div v-if="!isMobile">
              <p class="font-weight-normal h6">A ativação foi concluída e você já pode realizar consultas on-line.</p>
            </div>
             <p class="espaco"></p>
              <p class="espaco"></p>
            <p>*Caso tenha ativado dependentes, eles receberão a senha de acesso por e-mail.</p>
          </div>      
          <div class="relative mt-2 text-center">
            <p class="espaco"></p>
            <p class="mensagemFalha">Em caso de dúvidas ou problemas de acesso entre em contato agora mesmo. <a href="/suporte">Clique aqui.</a></p>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
  </div>   
</template>

<script>
import OctadeskComponent from '@/components/OctadeskComponent'
import TopoComponent from '@/components/TopoComponent'
export default {
  name: 'sucesso',
  components: {
      TopoComponent, OctadeskComponent
  },
  data() {
    return {
        userToken : sessionStorage.getItem("token"),
        isIOS: (/iphone|ipad|ipod/i.test(navigator.userAgent.toLowerCase())),
        isAndroid: (/android/i.test(navigator.userAgent.toLowerCase())),
        isOutroDisp: (/webos|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase())),
        isMobile: (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase())),
        androidUrl: 'https://play.google.com/store/apps/details?id=br.com.conexasaude',
        iosUrl: 'https://apps.apple.com/us/app/conexa-sa%C3%BAde/id1476749720',
        acessoDiretoAppUrl: null,
        linkMagicoApp: null,
        linkMagicoWeb: null,
        origem : sessionStorage.getItem("origem"),
        isConexaApp: true
    }
  },
  mounted() {
    this.carregarLinkMagico()
    this.carregarLinkAppEmpresa()
  },
  methods:{
    acessarAgora(){
        if(this.isMobile){
           location.href = this.linkMagicoApp
        }else{
           location.href = this.linkMagicoWeb
        }
    },
    carregarLinkAppEmpresa(){
      this.$conexaApi.get('/clinica/urls/app/'+sessionStorage.getItem("idclinica"))
      .then((response) => {
          this.androidUrl = response.data.object.urlAndroid
          this.iosUrl = response.data.object.urlIos
          this.acessoDiretoAppUrl = response.data.object.urlAcessoDiretoApp
           
          if(this.androidUrl != null && this.androidUrl.indexOf("conexa") >= 0){
            this.isConexaApp = true
          }else{
            this.isConexaApp = false
          }
      }) .catch((error) => {
          this.androidUrl = 'https://play.google.com/store/apps/details?id=br.com.conexasaude'
          this.iosUrl = 'https://apps.apple.com/us/app/conexa-sa%C3%BAde/id1476749720'
      }).finally(() => {
         NProgress.done()
      })  
    },
    carregarLinkMagico(){
      this.$conexaApi.get('/integration/ativacao/paciente/'+this.userToken+'/gerar-link-magico')
      .then((response) => {
          let redirectTo = sessionStorage.getItem('redirectTo');
          this.linkMagicoApp = response.data.object.linkMagicoApp
          if(redirectTo) this.linkMagicoWeb = `${response.data.object.linkMagicoWeb}/${redirectTo}`
          else this.linkMagicoWeb = response.data.object.linkMagicoWeb
          //Evita que va para o app, ja loga logo na web  
          if(sessionStorage.getItem("clinica-direcionada") != null){
             location.href = this.linkMagicoWeb
          }else{
            if (!this.isMobile){
               location.href = this.linkMagicoWeb
            }
          }
         
      }) .catch((error) => {
          //   this.$notify({
          //     duration: 4000,
          //     group: 'mensagens',
          //     type: 'error', 
          //     title: 'Mensagem',
          //     text: error.response.data.msg
          // })
      })
    }
  }
}
</script>

<style  scoped>
.span{
    color:darkgray;
    font-weight: bold;
}
.mensagemFalha{
   color: gray;
   font-size: 20px;
}
.baixeApp{
   color: #3cb4e7;
   font-weight: bold;
   text-align: center;
}
.imgApp{
    margin-right: 20px;
    margin-top: 10px;
}
.espaco{
  margin: 50px;
}
.center{
  text-align: center 
}
</style>